import { AfterViewInit, Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: 'error-page-component',
    template: '<ui-view></ui-view>',
    styleUrls: ["./error.style.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ErrorPageComponent implements AfterViewInit {
  ngAfterViewInit() { document.body.classList.add('loaded'); }
}
